<template>
  <div class="list-group-item">
    <v-divider :key="graph.id" :inset="true"></v-divider>
    <v-list-tile avatar :id="chartReorderRowId">
      <v-list-tile-avatar>
        <img v-bind:src="chartImage">
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-html="graphTitle"></v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-icon>reorder</v-icon>
      </v-list-tile-action>
    </v-list-tile>
  </div>
</template>

<script>
  import { mapActions, mapMutations, mapState } from 'vuex'

  export default {
    name: 'reorder-row',
    mixins: [],
    data () {
      return {}
    },
    methods: {
      ...mapActions({
      }),
      ...mapMutations({
      })
    },
    computed: {
      ...mapState({
        chartTypes: state => state.dashboard.availableCharts
      }),
      graphTitle () {
        let key = `dashboard.${this.graph.chartTitle}`
        if (this.$i18n.keyExists(key)) {
          return this.$t(key)
        } else {
          return this.graph.chartTitle
        }
      },
      chartReorderRowId () {
        return 'reorder-list-row-' + this.graph.id
      },
      chartImage () {
        return `/static/img/charts/` + this.graph.chartType.toLowerCase() + `.svg`
      }
    },
    props: {
      dialog: {
        default: false
      },
      graph: {
        type: Object,
        required: true
      }
    }
  }
</script>

<style scoped>
  .filter-list-rows {
    overflow: auto;
    height: 55vh;
    max-height: calc(100vh - 340px);
    -webkit-overflow-scrolling: touch;
  }
  /* Transitions */
  .filter-list-enter-active,
  .filter-list-leave-active {
    transition: all 0.4s;
    opaque: 1;
  }

  .filter-list-enter, .filter-list-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
    transform: translate(-16px, 0px)
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/ReorderRow.vue